export default __webpack_public_path__ + "static/media/vendor-icon.559534dc.svg";